import React, { FunctionComponent } from 'react'

import PuxPicture, { PuxPictureType } from '../content/mediaImage/PuxPicture'

export interface EasySoftwareIconBarItemType {
  displayText: string
  iconBarItemImage: PuxPictureType
}

const EasySoftwareIconBarItem: FunctionComponent<EasySoftwareIconBarItemType> = (
  props
) => {
  return (
    <div className='IconBar-item'>
      <PuxPicture {...props.iconBarItemImage} height={32} width={32} />
      <div className='IconBar-item title'>{props.displayText}</div>
    </div>
  )
}

export default EasySoftwareIconBarItem
